module.exports = __webpack_public_path__ + "img/generatePayslip.9ff2ca5d.svg";